import {Component, Inject, Input, OnInit, ViewEncapsulation} from "@angular/core";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {ApiService} from "../../services/api/api.service";
import {Series} from "../../_models/series";
import {SearchQueryOptions} from "../../services/api/search-query-options";
import {DownloadService} from "../../services/csv-download.service";
import {ConstantProperty} from "../../_models/constant-property";
import {NotificationService} from "../../services/notification.service";
import {ListResponse} from "../../services/api/response-types";
import {DateTimeInstanceService} from "../../services/date-time-instance.service";
import {COMMON_DIALOG_IMPORTS, COMMON_FORM_IMPORTS} from "../../shared/import-groups/Common";
import {
    SelectSearchComponentComponent
} from "../../components/select-search-api/single/select-search-component.component";
import {SelectManySeriesComponent} from "../../components/select-search-api/many/wrappers/select-many-series.component";
import {SelectSearchComponent} from "../../components/select-search/select-search.component";
import {SelectManySearchComponent} from "../../components/select-search/select-many-search.component";
import {CommonModule} from "@angular/common";
import {SelectManySearchBaseComponent} from "../../components/select-search-api/many/select-many-search-base.component";
import {ComponentType} from "../../_models/component-type";

@Component({
    selector: 'FileDownloadForm',
    templateUrl: 'file_download_form.component.html',
    imports: [
        CommonModule,
        COMMON_DIALOG_IMPORTS,
        SelectSearchComponentComponent,
        SelectManySeriesComponent,
        COMMON_FORM_IMPORTS,
        SelectManySearchComponent
    ],
    encapsulation: ViewEncapsulation.None
})

export class DownloadFormDialogComponent implements OnInit {
    public selected_data: any = {process: null};
    showing_hints: boolean = false;
    hint: string = 'Name';
    full_series_list: Series[] = [];
    @Input()
    selected_series: Series[] = [];
    selectAllConstantProperties: boolean;
    selectedConstantProperties: ConstantProperty[] = [];
    selectedComponentType: ComponentType;
    allComponentTypeConstantProperties: ConstantProperty[] = [];
    selectedTabIndex = 0;
    download_all_children: boolean = false;
    processFilters: any[];

    constructor(
        public api: ApiService,
        public dialogRef: MatDialogRef<DownloadFormDialogComponent>,
        private dateInst: DateTimeInstanceService,
        public DownloadService: DownloadService,
        private notification: NotificationService,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
    }

    ngOnInit(): void {
        const ctrl = this;

        // this option is to filter out only process with series data in by assuming that these processes will appear in the mapping table
        this.processFilters = [
            {
                name: 'series_components',
                op: 'any',
                val: {
                    name: 'id',  // field name in series_components
                    op: 'ne',
                    val: null
                }
            }
        ];

        if (this.data) {
            ctrl.selected_series = ctrl.data;
        }
    }

    selectComponentType(componentType) {
        this.selectedComponentType = componentType;
        this.fetchConstantProperties(componentType?.id);
    }

    fetchConstantProperties(component_type) {
        const options = new SearchQueryOptions();
        options.filters = [
            {
                name: 'component_types',
                op: 'any',
                val: {name: 'id', op: 'in', val: [component_type]}
            }
        ];

        this.api.constant_property_light.searchMany(options).subscribe((response) => {
            this.allComponentTypeConstantProperties = response.data;
        });
    }

    clearTabData(event = null) {
        if (event.index === 0) {
            this.selectedComponentType = undefined;
        } else if (event.index === 1) {
            this.selected_data.process = '';
            this.selected_series = [];
        }
    }

    downloadComponentTypeData() {
        if (this.selectedComponentType) {
            if (this.selectAllConstantProperties) {
                this.DownloadService.downloadComponentDataCsv(
                    this.dateInst.dtp.start.toISOString(),
                    this.dateInst.dtp.end.toISOString(), this.selectedComponentType.id);
            } else {
                if (this.selectedConstantProperties?.length === 0) {
                    this.notification.openError('Please select constant properties or select all');
                } else {
                    this.DownloadService.downloadComponentDataCsv(
                        this.dateInst.dtp.start.toISOString(),
                        this.dateInst.dtp.end.toISOString(),
                        this.selectedComponentType.id,
                        this.selectedConstantProperties.map(constantProperties => constantProperties.id)
                    );
                }
            }
        } else {
            this.notification.openError('Please select a Component Type');
        }
    }

    downloadData = () => {
        let params: Record<string, any> = {
            start: this.dateInst.dtp.start.toISOString(),
            end: this.dateInst.dtp.end.toISOString(),
            sample_period: this.dateInst.dtp.sample_period.wire_sample,
            deepness: this.download_all_children ? 100 : 1
        };
        if (this.selected_data?.process?.id) {
            params['process'] = this.selected_data.process.id;
        }
        if (this.selected_series) {
            params['series_list'] = this.selected_series.map(series => series.id);
        }
        this.DownloadService.downloadExcel(params);
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }
}
